import { ToolName } from '@debbie/common/dist/agents/index.js';
import React from 'react';
import CreateCreditorMessageBody from './CreateCreditorMessageBody.js';
import CreateInteractionBody from './CreateInteractionBody.js';
import CreatePaymentPlanBody from './CreatePaymentPlanBody.js';
import CreateUpdateBody from './CreateUpdateBody.js';
import EndCaseBody from './EndCaseBody.js';
import { RawJson } from './shared.js';
const ProposalBody = ({ toolName, proposedInput, caseId, showValidationErrors = true, onEditsChange, }) => {
    switch (toolName) {
        case ToolName.CreateInteraction:
            return (React.createElement(CreateInteractionBody, { input: proposedInput, caseId: caseId, onEditsChange: onEditsChange }));
        case ToolName.CreateCreditorMessage:
            return (React.createElement(CreateCreditorMessageBody, { input: proposedInput, caseId: caseId, onEditsChange: onEditsChange }));
        case ToolName.CreatePaymentPlan:
            return (React.createElement(CreatePaymentPlanBody, { input: proposedInput, caseId: caseId, showValidationErrors: showValidationErrors, onEditsChange: onEditsChange }));
        case ToolName.CreateUpdate:
            return (React.createElement(CreateUpdateBody, { input: proposedInput, onEditsChange: onEditsChange }));
        case ToolName.EndCase:
            return (React.createElement(EndCaseBody, { input: proposedInput, caseId: caseId }));
        default:
            return React.createElement(RawJson, null, JSON.stringify(proposedInput, null, 2));
    }
};
export default ProposalBody;
//# sourceMappingURL=ProposalBody.js.map